import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CasesPage from "../pages/cases/page";
import CaseDetailPage from "../pages/cases/detail/page";
import AboutPage from "../pages/about/page";
import FaqPage from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cases",
    element: <CasesPage />,
  },
  {
    path: "/cases/:id",
    element: <CaseDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;